import heroCastleImg from "./assets/images/hero-castle.webp";
import realmsCityImg from "./assets/images/realms-city.webp";
import diceBookImg from "./assets/images/dice-book.webp";
import logoImg from "./assets/images/logo.webp";
import rowengardNightImg from "./assets/images/rowengard-night.webp";
import vranodoliWildsImg from "./assets/images/vranodoli-wilds.webp";
import logoBankaImg from "./assets/images/logo-banka.webp";

// Draconia RP assets (AI-generated), self-hosted + WebP-compressed:
// previously realmsCity/diceBook were hotlinked to a third-party CDN
// (static.prod-images.emergentagent.com) - a single point of failure and an
// avoidable extra DNS/TLS round-trip on every load.
export const ASSETS = {
  heroCastle: heroCastleImg,
  realmsCity: realmsCityImg,
  diceBook: diceBookImg,
  logo: logoImg,
  rowengardNight: rowengardNightImg,
  vranodoliWilds: vranodoliWildsImg,
  logoBanka: logoBankaImg,
};
